var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('table',{staticClass:"basic_table"},[_c('tr',[_c('th',[_vm._v("適用ルール")]),_c('td',[_vm._v(_vm._s(_vm.getRule))])]),_c('tr',[_c('th',[_vm._v("基本料金(自動計算)")]),_c('td',[_c('DigitSeparatorsLabel',{staticClass:"price",attrs:{"value":_vm.getPrice}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }